// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"64c98a64","31":"6e95509f","390":"3aa3204e","896":"eec258f7"}[chunkId] + ".chunk.js";
};